import React, {Component} from 'react';

import PageHeader from "../../system/components/PageHeader";
import Aux from "../../system/containers/Aux";

class Dashboard extends Component {
    render() {
        return (
            <Aux>
                <PageHeader title="Dashboard" />
            </Aux>
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/containers/dashboard/index.jsx